<template>
  <section class="bg-[#ededec] px-6 lg:px-16 xl:px-40 py-16 md:py-24">
    <div class="flex items-start gap-2 mb-6 md:mb-8">
      <div class="bg-primary-dark rounded-[2px] w-3 h-3 mt-[13px] shrink-0" />
      <h2 class="font-display font-semibold text-3xl md:text-[56px] leading-tight text-surface-1 !mt-0 !mb-0">
        {{ t('home.approachTitle') }}
      </h2>
    </div>

    <p class="font-sans text-lg md:text-xl text-surface-1/80 max-w-3xl mb-12 md:mb-16 !mt-0">
      {{ t('home.approachIntro') }}
    </p>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <article
        v-for="pillar in pillars" :key="pillar.key"
        class="relative overflow-hidden rounded bg-surface-1 min-h-[480px] md:min-h-[640px] shadow-[0_24px_60px_-20px_rgba(0,0,0,0.25)]"
      >
        <img
          :src="pillar.bgUrl"
          alt=""
          aria-hidden="true"
          class="absolute left-0 right-0 bottom-0 w-full h-[80%] object-cover object-bottom"
        />
        <div
          class="absolute left-0 right-0 bottom-0 h-[80%] pointer-events-none"
          style="background: linear-gradient(180deg, #111111 0%, rgba(17,17,17,0) 100%);"
        />

        <div class="relative flex items-start justify-end p-6">
          <RouterLink
            :to="{ name: 'approach', hash: `#pillar-${pillar.key}` }"
            :aria-label="t('home.approachCardLink')"
            class="inline-flex items-center justify-center w-11 h-11 rounded-full bg-primary hover:bg-primary-dark text-white hover:text-white transition-colors"
          >
            <VaIcon name="arrow_outward" :size="22" />
          </RouterLink>
        </div>

        <div class="relative flex flex-col gap-4 px-6 pb-6">
          <h3 class="font-display font-semibold text-xl md:text-2xl leading-snug text-white !mt-0 !mb-0">
            {{ t(`home.pillars.${pillar.key}.title`) }}
          </h3>
          <p
            v-for="(paragraph, idx) in t(`home.pillars.${pillar.key}.body`).split('\n\n')"
            :key="idx"
            class="font-sans text-sm md:text-base text-white/85 !mt-0 !mb-0"
          >
            {{ paragraph }}
          </p>
          <RouterLink
            :to="{ name: 'approach', hash: `#pillar-${pillar.key}` }"
            class="inline-flex items-center gap-1 mt-1 font-sans text-sm text-white hover:text-primary transition-colors"
          >
            {{ t('home.approachCardLink') }}
            <VaIcon name="arrow_forward" :size="16" />
          </RouterLink>
        </div>
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VaIcon } from 'vuestic-ui'
import pillarFitsUrl from '@/assets/images/pillar-fits.webp?url'
import pillarSpeedUrl from '@/assets/images/pillar-speed.webp?url'
import pillarAiUrl from '@/assets/images/pillar-ai.webp?url'

const { t } = useI18n()

const pillars = [
  { key: 'fits', bgUrl: pillarFitsUrl },
  { key: 'speed', bgUrl: pillarSpeedUrl },
  { key: 'ai', bgUrl: pillarAiUrl },
] as const
</script>
